import { cn } from "../../utils";

export interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({ children, className }) => {
  return (
    <div
      className={cn(
        "ui:flex ui:rounded-lg ui:bg-white ui:p-4 ui:shadow-[0px_2px_14px_0px_rgba(201,201,201,0.50)] ui:dark:border ui:dark:border-divider ui:dark:bg-transparent ui:dark:shadow-none",
        className,
      )}
    >
      {children}
    </div>
  );
};
